import useApi from "./useApiRequest";
import { useMutation } from "react-query";

export const GetSubalmacenes = ()  => {
    const api = useApi();

    const mutate = async (params) => {
        const data  = await api.get(`/almacenes/subalmacenes/${params}`);
        return data.data;
    };

    const mutation = useMutation(mutate);

    return {
        getSubalmacenesMutation: mutation.mutate,
    };
}